import FacebookIcon from '../../assets/social-media-icons/facebook.png';
import InstagramIcon from '../../assets/social-media-icons/instagram.png';
import LinkedInIcon from '../../assets/social-media-icons/linkedin.png';
import XIcon from '../../assets/social-media-icons/x.png';
import ThreadsIcon from '../../assets/social-media-icons/threads.png';
import BlueskyIcon from '../../assets/social-media-icons/bluesky.png';
import SMSIcon from '../../assets/social-media-icons/sms.png';
import DiscordIcon from '../../assets/social-media-icons/discord.png';
import SignalIcon from '../../assets/social-media-icons/signal.png';
import TelegramIcon from '../../assets/social-media-icons/telegram.png';

interface PlatformConfig {
  name: string;
  icon: string;
  headerColor: string;
  actions: {
    icon: string;
    label: string;
    count?: string;
  }[];
  hashtagColor: string;
  linkColor: string;
}

export const PLATFORM_CONFIGS: Record<string, PlatformConfig> = {
  facebook: {
    name: 'Facebook',
    icon: FacebookIcon,
    headerColor: 'bg-[#1877F2]',
    actions: [
      { icon: '👍', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '↗️', label: 'Share' },
    ],
    hashtagColor: 'text-[#1877F2]',
    linkColor: 'text-[#1877F2]',
  },
  instagram: {
    name: 'Instagram',
    icon: InstagramIcon,
    headerColor: 'bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#FCAF45]',
    actions: [
      { icon: '❤️', label: '0 likes' },
      { icon: '💬', label: '0 comments' },
      { icon: '↗️', label: 'Share' },
    ],
    hashtagColor: 'text-[#00376B]',
    linkColor: 'text-[#00376B]',
  },
  linkedin: {
    name: 'LinkedIn',
    icon: LinkedInIcon,
    headerColor: 'bg-[#0A66C2]',
    actions: [
      { icon: '👍', label: 'Like' },
      { icon: '💬', label: 'Comment' },
      { icon: '↗️', label: 'Repost' },
    ],
    hashtagColor: 'text-[#0A66C2]',
    linkColor: 'text-[#0A66C2]',
  },
  twitter: {
    name: 'X (formerly Twitter)',
    icon: XIcon,
    headerColor: 'bg-black',
    actions: [
      { icon: '❤️', label: '0' },
      { icon: '🔄', label: 'Repost' },
      { icon: '💬', label: 'Reply' },
    ],
    hashtagColor: 'text-[#1DA1F2]',
    linkColor: 'text-[#1DA1F2]',
  },
  x: {
    name: 'X (Twitter)',
    icon: XIcon,
    headerColor: 'bg-black',
    actions: [
      { icon: '❤️', label: '0' },
      { icon: '🔄', label: 'Repost' },
      { icon: '💬', label: 'Reply' },
    ],
    hashtagColor: 'text-[#1DA1F2]',
    linkColor: 'text-[#1DA1F2]',
  },
  threads: {
    name: 'Threads',
    icon: ThreadsIcon,
    headerColor: 'bg-black',
    actions: [
      { icon: '❤️', label: '0' },
      { icon: '💬', label: 'Reply' },
      { icon: '🔄', label: 'Repost' },
      { icon: '↗️', label: 'Share' },
    ],
    hashtagColor: 'text-[#1DA1F2]',
    linkColor: 'text-[#1DA1F2]',
  },
  bluesky: {
    name: 'Bluesky',
    icon: BlueskyIcon,
    headerColor: 'bg-[#00A8E8]',
    actions: [
      { icon: '❤️', label: '0' },
      { icon: '🔄', label: 'Repost' },
      { icon: '💬', label: 'Reply' },
    ],
    hashtagColor: 'text-[#00A8E8]',
    linkColor: 'text-[#00A8E8]',
  },
  sms: {
    name: 'SMS',
    icon: SMSIcon,
    headerColor: 'bg-[#34C759]',
    actions: [{ icon: '↗️', label: 'Send' }],
    hashtagColor: 'text-[#007AFF]',
    linkColor: 'text-[#007AFF]',
  },
  discord: {
    name: 'Discord',
    icon: DiscordIcon,
    headerColor: 'bg-[#5865F2]',
    actions: [
      { icon: '👍', label: '0' },
      { icon: '👎', label: '0' },
      { icon: '💬', label: 'Reply' },
    ],
    hashtagColor: 'text-[#5865F2]',
    linkColor: 'text-[#00AFF4]',
  },
  signal: {
    name: 'Signal',
    icon: SignalIcon,
    headerColor: 'bg-[#3A76F0]',
    actions: [{ icon: '↗️', label: 'Send' }],
    hashtagColor: 'text-[#3A76F0]',
    linkColor: 'text-[#3A76F0]',
  },
  telegram: {
    name: 'Telegram',
    icon: TelegramIcon,
    headerColor: 'bg-[#0088CC]',
    actions: [
      { icon: '👍', label: '0' },
      { icon: '👎', label: '0' },
      { icon: '↗️', label: 'Forward' },
    ],
    hashtagColor: 'text-[#0088CC]',
    linkColor: 'text-[#0088CC]',
  },
};
